import { stableSort, getSorting, GetUniqueDataItem, dateFormatDisplay, } from '../../../Functions';
export function LRExcel(XLSX, data) {
    console.log('data', data)

    var header = data.header;
    var detail = data.details;

    var wb = XLSX.utils.book_new();

    if(header && header.destination && header.destination.length > 0){
        let NotDestDetail = [];
        let EmptyContainer = [];
        //#region 
        header.destination.forEach(dest => {
            let hasDestination = detail.filter(d => d.destination === dest.destinationBranchCode && d.wayBillRef);
            if(hasDestination && hasDestination.length > 0){
                // Header
                var ws = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

                XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "OCEAN TRANSPORT GROUP OF COMPANIES INC.", }], { header: [], skipHeader: true, origin: -1 });
                XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "CONTAINERIZED CARGO LOADING REPORT", }], { header: [], skipHeader: true, origin: -1 });
                XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "Loading Report " + header.voyageRef + " / " + header.vessel + " " + header.voyageNum + " " + header.routes, }], { header: [], skipHeader: true, origin: -1 });

                XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J: "", K: "", L: "", M: "", N: "", O: "Total TEUs" }], { header: [], skipHeader: true, origin: -1 });
                XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J: "", K: "", L: "", M: "", N: "", O: detail.length }], { header: [], skipHeader: true, origin: -1 });

                XLSX.utils.sheet_add_json(ws, [
                    {
                        A: "", 
                        B: "Booking Date", 
                        C: "CTS Date", 
                        D: "CY-IN", 
                        E: "BOOKING REF",
                        F: "WAYBILL", 
                        // E: "OLD WAYBILL REF",
                        G: "SHIPPER", 
                        H: "SHIPPER PREFERRED NAME",
                        I: "CONSIGNEE", 
                        J: "CONSIGNEE PREFERRED NAME",
                        K: "DESCRIPTION",
                        L: "VAN NUMBER", 
                        M: "SEAL NO.", 
                        N: "TRUCKING",
                        O: "PLATE NO.",
                        P: "DRIVER",
                        Q: "WEIGHT (TONS)", 
                        R: "SIZE", 
                        S: "DEL. MODE", 
                        T: "PAY MODE",
                        U: "CARGO TYPE", 
                        V: "CONTAINER TYPE", 
                        W: "DESTINATION",
                        X: "VALUE", 
                        Y: "REMARKS", 
                    }
                ], { header: [], skipHeader: true, origin: -1 });
            
                stableSort(detail.filter(d => d.destination === dest.destinationBranchCode && d.wayBillRef), getSorting('asc', 'wayBillRef')).forEach((element, index) => {
                    let Bookingdate = element.bookingDate && element.bookingDate !== "" ? dateFormatDisplay(new Date(element.bookingDate)) : "";
                    let CTSdate = element.ctsDate && element.ctsDate !== "" ? dateFormatDisplay(new Date(element.ctsDate)) : "";
                    let CYdate = element.cyIn && element.cyIn !== "" ? dateFormatDisplay(new Date(element.cyIn)) : "";
                    // let FinalRemark = '';
                    // if(element.remarks && element.remarks !== ""){
                    //   if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "PTD"){
                    //     if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING, ' + element.remarks; }
                    //     else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, ' + element.remarks; } 
                    //     else { FinalRemark = 'GROUNDING, ' + element.remarks; }
                    //   } else {
                    //     if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING MANO, ' + element.remarks; }
                    //     else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, ' + element.remarks; }
                    //     else if(element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, STUFFING MANO, ' + element.remarks; } 
                    //     else { FinalRemark = 'GROUNDING, ' + element.remarks; }
                    //   }
                    // } else {
                    //   if(element.modeOfDelivery === "PTP" || element.modeOfDelivery === "PTD"){
                    //     if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING'; }
                    //     else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD'; } 
                    //     else { FinalRemark = 'GROUNDING'; }
                    //   } else {
                    //     if(element.stuffing && !element.originBackload){ FinalRemark = 'STUFFING MANO'; }
                    //     else if(!element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD'; }
                    //     else if(element.stuffing && element.originBackload) { FinalRemark = 'GROUNDING, BACKLOAD, STUFFING MANO'; } 
                    //     else { FinalRemark = 'GROUNDING'; }
                    //   }
                    // }
                    let FinalRemark = [];
                    if(element.remarks && element.remarks !== ""){FinalRemark.push(element.remarks);}
                    if(element.originBackload){FinalRemark.push("BACKLOAD");}
                    if(element.modeOfDelivery === "PTP"){
                        if(element.stuffing){FinalRemark.push("STUFFING");}
                        else {FinalRemark.push("VAN OUT ORIGIN");}
                        if(element.isStripping){FinalRemark.push("STRIPPING");}
                        else {FinalRemark.push("VAN OUT DESTINATION");}
                    }
                    else if(element.modeOfDelivery === "PTD"){
                        if(element.stuffing){FinalRemark.push("STUFFING");}
                        else {FinalRemark.push("VAN OUT ORIGIN");}
                        if(element.isStripping){FinalRemark.push("STRIPPING MANO");}
                        else {FinalRemark.push("GROUNDING");}
                    }
                    else if(element.modeOfDelivery === "DTP"){
                        if(element.stuffing){FinalRemark.push("STUFFING MANO");}
                        else {FinalRemark.push("GROUNDING");}
                        if(element.isStripping){FinalRemark.push("STRIPPING");}
                        else {FinalRemark.push("VAN OUT DESTINATION");}
                    }
                    else {
                        if(element.stuffing){FinalRemark.push("STUFFING MANO");}
                        else {FinalRemark.push("GROUNDING");}
                        if(element.isStripping){FinalRemark.push("STRIPPING MANO");}
                        else {FinalRemark.push("GROUNDING");}
                    }
                    let UniqueRemark = '';
                    if(FinalRemark && FinalRemark.length > 0){
                        UniqueRemark = GetUniqueDataItem(FinalRemark).join(", ");
                    }
                    XLSX.utils.sheet_add_json(ws, [
                        {
                            A: index + 1, 
                            B: Bookingdate,
                            C: CTSdate,
                            D: element.wayBillRef ? CYdate : '', 
                            E: element.bookingRef,
                            F: element.wayBillRef,
                            // E: element.oldWaybillRef,
                            G: element.shipper, 
                            H: element.shipperPreferedName, 
                            I: element.consignee,
                            J: element.consigneePreferedName,
                            K: element.goods, 
                            L: element.vanNumber,
                            M: element.sealNum, 
                            N: element.truckerName,
                            O: element.plateNum,
                            P: element.driver,
                            Q: element.cargoWeight ? element.cargoWeight : '',
                            R: element.size, 
                            S: element.modeOfDelivery, 
                            T: element.modeOfPayment,
                            U: element.cargoType, 
                            V: element.wayBillRef ? "FL" : "EMPTY", 
                            W: element.destinationBranch, 
                            X: element.declaredValue ? element.declaredValue : '',
                            Y: UniqueRemark,
                        }
                    ], { header: [], skipHeader: true, origin: -1 });
                });
            
                var wscols = [
                    { wch: 4 },  // Count
                    { wch: 15 }, // Booking Date
                    { wch: 15 }, // CTS Date
                    { wch: 10 }, // CY-In
                    { wch: 15 }, // Booking Ref
                    { wch: 15 }, // Waybill
                    // { wch: 15 }, // Waybill
                    { wch: 30 }, // Shipper
                    { wch: 30 }, // Shipper
                    { wch: 30 }, // Consignee
                    { wch: 30 }, // Consignee
                    { wch: 20 }, // Goods
                    { wch: 15 }, // Van Number
                    { wch: 12 }, // Seal Number
                    { wch: 30 }, // Trucker
                    { wch: 10 }, // Plate no
                    { wch: 15 }, // Driver
                    { wch: 13 }, // Weight
                    { wch: 6 }, // Size
                    { wch: 10 }, // Mode of Delivery
                    { wch: 17 }, // Mode of Payment
                    { wch: 11 }, // Cargo Type
                    { wch: 15 }, // CONTAINER TYPE
                    { wch: 15 }, // Destination
                    { wch: 15 }, // Declared Value
                    { wch: 25 }, // Remarks                  
                ];
            
                ws['!cols'] = wscols;
            
                XLSX.utils.book_append_sheet(wb, ws, "Loading Report " + dest.destinationBranchName);
            }
        });
        //#endregion

        //#region Transship
        header.destination.forEach(dest => {
            detail.filter(d => d.destination !== dest.destinationBranchCode && d.wayBillRef).forEach(dest => {
                if(NotDestDetail && NotDestDetail.length > 0){
                    let findBook = NotDestDetail.find(d => d.bookingRef === dest.bookingRef);
                    if(!findBook){
                        NotDestDetail.push({...dest})
                    }
                }
                else {
                    NotDestDetail.push({...dest})
                }

            });
        });

        header.destination.forEach(dest => {
            NotDestDetail = NotDestDetail.filter(d => d.destination !== dest.destinationBranchCode);
        })
        
        if(NotDestDetail && NotDestDetail.length > 0){
            // Header
            var ws = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

            XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "OCEAN TRANSPORT GROUP OF COMPANIES INC.", }], { header: [], skipHeader: true, origin: -1 });
            XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "CONTAINERIZED CARGO LOADING REPORT", }], { header: [], skipHeader: true, origin: -1 });
            XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "Loading Report " + header.vessel + " " + header.voyageNum + " " + header.routes, }], { header: [], skipHeader: true, origin: -1 });

            XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J: "", K: "", L: "", M: "", N: "", O: "Total TEUs" }], { header: [], skipHeader: true, origin: -1 });
            XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "", I: "", J: "", K: "", L: "", M: "", N: "", O: detail.length }], { header: [], skipHeader: true, origin: -1 });

            XLSX.utils.sheet_add_json(ws, [
                {
                    A: "", 
                    B: "Booking Date", 
                    C: "CTS Date", 
                    D: "CY-In", 
                    E: "BOOKING REF",
                    F: "WAYBILL", 
                    // E: "OLD WAYBILL", 
                    G: "SHIPPER", 
                    H: "SHIPPER PREFERRED NAME", 
                    I: "CONSIGNEE", 
                    J: "CONSIGNEE PREFERRED NAME", 
                    K: "DESCRIPTION",
                    L: "VAN NUMBER", 
                    M: "Seal No.", 
                    N: "WEIGHT (TONS)", 
                    O: "SIZE", 
                    P: "DEL. MODE", 
                    Q: "PAY MODE",
                    R: "CARGO TYPE", 
                    S: "VALUE", 
                    T: "REMARKS", 
                    U: "CONTAINER TYPE", 
                    V: "DESTINATION"
                }
            ], { header: [], skipHeader: true, origin: -1 });

            stableSort(NotDestDetail, getSorting('asc', 'wayBillRef')).forEach((element, index) => {
                let Bookingdate = element.bookingDate && element.bookingDate !== "" ? dateFormatDisplay(new Date(element.bookingDate)) : "";
                let CTSdate = element.ctsDate && element.ctsDate !== "" ? dateFormatDisplay(new Date(element.ctsDate)) : "";
                let CYdate = element.cyIn && element.cyIn !== "" ? dateFormatDisplay(new Date(element.cyIn)) : "";
            
                XLSX.utils.sheet_add_json(ws, [
                    {
                        A: index + 1, 
                        B: Bookingdate, 
                        C: CTSdate, 
                        D: element.wayBillRef ? CYdate : '', 
                        E: element.bookingRef,
                        F: element.wayBillRef,
                        // E: element.oldWaybillRef,
                        G: element.shipper, 
                        H: element.shipperPreferedName, 
                        I: element.consignee,
                        J: element.consigneePreferedName,
                        K: element.goods, 
                        L: element.vanNumber,
                        M: element.sealNum, 
                        N: element.cargoWeight ? element.cargoWeight : '',
                        O: element.size, 
                        P: element.modeOfDelivery, 
                        Q: element.modeOfPayment,
                        R: element.cargoType, 
                        S: element.declaredValue ? element.declaredValue : '', 
                        T: element.remarks,
                        U: element.wayBillRef ? "FL" : "EMPTY", 
                        V: element.destinationBranch
                    }
                ], { header: [], skipHeader: true, origin: -1 });
            });

            var wscols = [
                { wch: 4 },  // Count
                { wch: 15 }, // Booking Date
                { wch: 15 }, // CTS Date
                { wch: 10 }, // CY-In
                { wch: 15 }, // Booking Ref
                { wch: 15 }, // Waybill
                // { wch: 15 }, // Waybill
                { wch: 30 }, // Shipper
                { wch: 30 }, // Shipper
                { wch: 30 }, // Consignee
                { wch: 30 }, // Consignee
                { wch: 20 }, // Goods
                { wch: 15 }, // Van Number
                { wch: 12 }, // Seal Number
                { wch: 13 }, // Weight
                { wch: 6 }, // Size
                { wch: 10 }, // Mode of Delivery
                { wch: 10 }, // Mode of Payment
                { wch: 11 }, // Cargo Type
                { wch: 15 }, // Declared Value
                { wch: 25 }, // Remarks
                { wch: 20 },
                { wch: 15 },
            ];

            ws['!cols'] = wscols;

            XLSX.utils.book_append_sheet(wb, ws, "Loading Report Transshipment");
        }
        //#endregion

        //#region Empty
        detail.filter(d => !d.wayBillRef).forEach(d => {
            EmptyContainer.push(d);
        })
        // console.log('EmptyContainer', EmptyContainer);
        if(EmptyContainer && EmptyContainer.length > 0){
            // Header
            var wsEmp = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

            XLSX.utils.sheet_add_json(wsEmp, [{ A: "", B: "", C: "OCEAN TRANSPORT GROUP OF COMPANIES INC.", }], { header: [], skipHeader: true, origin: -1 });
            XLSX.utils.sheet_add_json(wsEmp, [{ A: "", B: "", C: "CONTAINERIZED CARGO LOADING REPORT", }], { header: [], skipHeader: true, origin: -1 });
            XLSX.utils.sheet_add_json(wsEmp, [{ A: "", B: "", C: "Loading Report " + header.vessel + " " + header.voyageNum + " Empty Container" }], { header: [], skipHeader: true, origin: -1 });

            XLSX.utils.sheet_add_json(wsEmp, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: "Total TEUs" }], { header: [], skipHeader: true, origin: -1 });
            XLSX.utils.sheet_add_json(wsEmp, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "", H: detail.length }], { header: [], skipHeader: true, origin: -1 });

            XLSX.utils.sheet_add_json(wsEmp, [
                {
                    A: "", 
                    K: "VAN NUMBER", 
                    N: "SIZE", 
                    Q: "CARGO TYPE", 
                }
            ], { header: [], skipHeader: true, origin: -1 });

            stableSort(EmptyContainer, getSorting('asc', 'vanNumber')).forEach((element, index) => {
                XLSX.utils.sheet_add_json(wsEmp, [
                    {
                        A: index + 1, 
                        K: element.vanNumber,
                        N: element.size, 
                        T: "EMPTY", 
                    }
                ], { header: [], skipHeader: true, origin: -1 });
            });

            var wsEmpcols = [
                { wch: 4 },  // Count
                { wch: 15 }, // Van Number
                { wch: 6 }, // Size
                { wch: 11 }, // Cargo Type
            ];

            wsEmp['!cols'] = wsEmpcols;

            XLSX.utils.book_append_sheet(wb, wsEmp, "Loading Report Empty Container");
        }
        //#endregion
    }
    

    XLSX.writeFile(wb, "Loading_Report.xlsx")
}